<script lang="ts" setup>
import UserLink from "@/components/links/UserLink.vue";
import PhoneNumber from "@/components/PhoneNumber.vue";
import LanguageTag from "@/components/status/LanguageTag.vue";
import UserRole from "@/views/users/components/UserRole.vue";
import type { DriverDto } from "@/api/users/dto/driver.dto";
import type { OwnerDto } from "@/api/users/dto/owner.dto";
import { computed } from "vue";
import type { TruckDriverDto, TruckOwnerDto } from "@/api/trucks/dto/truck.dto";

const props = withDefaults(
  defineProps<{
    user: DriverDto | OwnerDto | TruckDriverDto | TruckOwnerDto;
    isDriver2?: boolean;
  }>(),
  {
    isDriver2: false,
  },
);

const phone = computed(() => {
  if ("phone" in props.user) {
    return props.user.phone;
  }

  if ("mobilePhone" in props.user) {
    return props.user.mobilePhone;
  }

  return "";
});
</script>

<template>
  <div>
    <div class="d-flex align-center col-gap-3">
      <user-role :user="user" />

      <user-link v-if="user.id" :id="user.id" :is-driver2="isDriver2" :name="user.name" />

      <phone-number v-if="phone" :number="phone" class="text-primary" />

      <language-tag v-if="user.language" :language="user.language" light />
    </div>
  </div>
</template>
